import React, {useReducer, useContext, useEffect} from 'react';
import { Box, TextField, Tooltip } from '@mui/material';
import MegaAutoComplete from '../Utils/megautocomplete';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { number2dayweek } from '../Utils/dayjsptbrhelper';
import DefaultModal from '../Utils/DefaultModal';
import { lockedReducer } from '../Utils/reducers';
import { externalComponent } from '../AppRoutes';
import ColorButton from '../Buttons/ColorButton';
import validateDataTable from './validateTabela';
import { api } from '../../services/api';
import toast from 'react-hot-toast';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IOSSwitch } from '../Utils/switch';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { PercentFormatInput } from '../Utils/PercentInput';
import { PercentFormatInputDefault } from '../Utils/PercentInputDefault';


const url = '/tabelas/'

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const loadRetrieve = async (id, setState, setLoader) => {
    setLoader(true)
    const res = await api.get(url + `${id}/`)
    if (res.status === 200) {
        setState({ ...res.data})
    }
    setLoader(false)
}

const submit = async (setLoader,data, getData,handleClose) => {
    
    setLoader(true)
    let res = null
    if (data.id)
    res = await api.patch(`${url}${data.id}/`, data)
    else
    res = await api.post(url, data)
    if (res.status === 200) {
        toast.success(`Tabela ${!data.id ? 'adicionado' : 'editado'} com sucesso`)
        getData()
    }else{
        toast.error(res.message)
    }
    setLoader(false)
    handleClose()

}

const getTipos = async (setLoader,setState) => {
    setLoader(true)
    const res = await api.get(url + 'tipo')
    if (res.status === 200) {
        setState({tiposTabela:res.data})
    }
    setLoader(false)

}

const getPrecoMinimoGlobal = async (setLoader,setState) => {
    setLoader(true)
    const res = await api.get('preco_minimo')
    if (res.status === 200) {
        setState({preco_minimo:res.data.preco_minimo})
    }
    setLoader(false)
}


const EditNovaTabela = ( {data, handleClose, reloadData} ) => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        editRow: null,
        tiposTabela:{},

        nome:'',
        grupo_filial:[],
        data_fim:'',
        desconto_valor_avista:'',
        comissao_promocional:0,
        preco_minimo:'',
        ativo:true,
        id_tipo:'',

        ...data,
        id: data.id ? data.id : 0
          
    })

    const { setLoader } = useContext(externalComponent)
    const validTable = validateDataTable(state)

    const changeComplete = (data, setState, state) => {
        if(state.grupo_filial.length === 0){
            const nome = data[0].data.default_name
            setState({nome:nome})
        }
        setState({grupo_filial:data})
        
    }

    useEffect(() => {
            getTipos(setLoader, setState)
            if (!data.id)
                getPrecoMinimoGlobal(setLoader, setState)
            
            if (data.id)
                loadRetrieve(data.id, setState, setLoader)
    }, [setLoader, data.id])

    return(
        <>
        <DefaultModal 
        dialogProps={{maxWidth:"sm"}}  
        handleClose={handleClose}
        open={true}
        title={`${getTitle(state)} Tabela`} 
        content={ 

            <Box className='item-content-modal noborder'>
                
                {
                    state.id === 0 ?

                    null
                    :
                    <Box className='item-profile-row'>
                    <FormControlLabel
                            control={<IOSSwitch sx={{ m: 1 }} checked={state.ativo} onChange={()=> setState({ativo:!state.ativo})} />}
                            label={state.ativo ? 'Ativo' : 'Desativado'}
                    />
                    </Box>
                }

                <Box className='item-profile-row'>
                    <MegaAutoComplete
                        multiple={true}
                        value={state.grupo_filial}
                        onChange={(data) => changeComplete(data, setState, state)}
                        noOptionsText={'Digite para procurar uma Filial'}
                        timeoutUrl='/tabela/grupo_filial/'
                        timeoutParam='label'
                        label='Grupo filial'
                    />
                </Box>

                <Box className='item-profile-row'>
                    <TextField
                        id="nomeTable"
                        type="text"
                        label="Nome"
                        size='small'
                        value={state.nome}
                        onChange={(e) => { setState({nome:e.target.value}) }}
                        fullWidth={false}
                        sx={{width:'100%'}}
                    />

                    <FormControl  size="small"> 
                        <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                        <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Status"
                        value={state.id_tipo}
                        onChange={(e)=> setState({id_tipo:e.target.value})}
                        sx={{width:'100%'}}
                        >
                        
                        {
                            Object.entries(state.tiposTabela).map(([key, value]) => (
                                <MenuItem key={key} value={key}>{value.nome}</MenuItem>
                            ))
                        }

                        </Select>
                    </FormControl>
                </Box>

                <Box className='item-profile-row' sx={{alignItems:'flex-end'}}>
            
                    <DemoContainer components={['DatePicker']}>
                        <DatePicker 
                        slotProps={{ textField: { size: 'small' } }} 
                        label="Data Fim" 
                        size="small" 
                        value={dayjs(state.data_fim)} 
                        onChange={(e)=> setState({data_fim:e.format('YYYY-MM-DD')})} 
                        format='DD/MM/YYYY'
                        dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                        ampm={false}
                        
                        />
                    </DemoContainer>

                    <TextField
                        id="desconto"
                        type="text"
                        label="Desconto à vista"
                        value={state.desconto_valor_avista}
                        onChange={(e) => { setState({ 'desconto_valor_avista': e.target.value }) }}
                        fullWidth={false}
                        size='small'
                        inputProps={{
                            maxLength: 50
                        }}
                        InputProps={{
                            inputComponent: PercentFormatInputDefault,
                        }}
                        sx={{width:'100%'}}
                    />
                </Box>

                <Box className='item-profile-row'>

                    <TextField
                        id="comissao_promocional"
                        type="text"
                        label="Comissão Promocional"
                        value={state.comissao_promocional}
                        onChange={(e) => { setState({ 'comissao_promocional': e.target.value }) }}
                        fullWidth={false}
                        size='small'
                        InputProps={{
                            inputComponent: PercentFormatInput,
                        }}

                        sx={{width:'50%'}}
                    />

                    <TextField
                        id="preco_minimo"
                        type="text"
                        label="Preço Mínimo"
                        value={state.preco_minimo}
                        onChange={(e) => { setState({ 'preco_minimo': e.target.value }) }}
                        fullWidth={false}
                        size='small'
                        inputProps={{
                            maxLength: 50
                        }}
                        InputProps={{
                            inputComponent: PercentFormatInputDefault,
                        }}
                        sx={{width:'50%'}}
                    />

                </Box>

             
            </Box>

        } 
        
        action={  
        <Tooltip title={validTable} placement="left">
            <span>
                <ColorButton disabled={validTable} onClick={()=> submit(setLoader,state,reloadData,handleClose)}>Salvar</ColorButton>
            </span>
        </Tooltip>
            }
        />
        
        


        </>
    )
}

export default EditNovaTabela;